import { render, staticRenderFns } from "./ContestStat.vue?vue&type=template&id=68f4bce2&"
import script from "./ContestStat.vue?vue&type=script&lang=js&"
export * from "./ContestStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports